// @flow

/**
 * @module Constants/Application
 * @desc Application Constants
 */

import keyMirror from 'fbjs/lib/keyMirror';

/**
 * @constant {Object} ApplicationConstants
 * @memberof Application
 */
export const ApplicationConstants = keyMirror({
  FETCH_APPLICATION_LIST: undefined,
  FETCH_OFFERS_LIST: undefined,
  FETCH_APPLICATION_FILTERS: undefined,
  PATCH_APPLICATION: undefined,
  GET_DOCUMENTS: undefined,
  UPLOAD_DOCUMENTS: undefined,
  FETCH_MERCHANT_DETAIL: undefined,
  GET_FEATURES: undefined,
  RESEND_EMAIL: undefined,
  GET_STATS: undefined,
  GET_REFUND_REASONS: undefined,
  GET_ACTIVE_CONTRACT: undefined,
  REFUND_REQUEST: undefined,
  GET_DEPOSIT_REFUNDS: undefined,
  DOWNLOAD_JSON_FROM_PRESIGN: undefined,
  GET_TEST_VALUES_DATA: undefined,
});



// WEBPACK FOOTER //
// ./src/constants/application.js